export default __webpack_public_path__ + "static/Hack-Regular-9dc3b46851425243312502b3c990c369.woff2";